import { api } from '@/core/api/'

export default {
  getPractitionerBySpecialist(id) {
    return api.get(`api/practitioner/practitionerbyspecialist/${id}`)
  },
  getPractitionerSpecialties(practitionerId) {
    return api.get(`api/practitioner/practitionerspecialties/${practitionerId}`)
  },
}
